import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { getMeetings } from '../../redux/meetings/meetingSlice';
import { formatDateTime, getStatusClass, truncateText } from '../../helper/helper';
import { useLocationFilter } from "../../context/LocationContext";
import PaginationHelper from '../../helper/PaginationHelper';

const MeetingLayer = () => {

    const dispatch = useDispatch();
    const { selectedLocation } = useLocationFilter();

    const meetings = useSelector((state) => state.meeting?.meetings) || [];
    const total = useSelector((state) => state.meeting?.total) || 0;

    const [search, setSearch] = useState("");
    const [entries, setEntries] = useState(50);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        dispatch(
            getMeetings({
                page: currentPage,
                limit: entries,
                locationId: selectedLocation?.value || "",
            })
        );
    }, [dispatch, currentPage, entries, selectedLocation]);

    const filteredMeetings = meetings.filter((m) =>
        `${m.sender?.fullName} ${m.receiver?.fullName} ${m.message}`
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    const totalEntries = filteredMeetings.length;
    const totalPages = Math.ceil(totalEntries / entries);

    const startIndex = (currentPage - 1) * entries;
    const endIndex = startIndex + entries;

    const paginatedMeetings = filteredMeetings.slice(startIndex, endIndex);

    return (
        <>
            <div className="card h-100 p-0 radius-12">

                {/* HEADER */}
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">

                    <div className="d-flex align-items-center flex-wrap gap-3">

                        <span className="text-md fw-medium text-secondary-light">
                            Show
                        </span>

                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={entries}
                            onChange={(e) => {
                                setEntries(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                        >
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="150">150</option>
                            <option value="200">200</option>
                        </select>

                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto"
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>

                    </div>

                </div>

                {/* TABLE */}
                <div className="card-body p-12">
                    <div className="table-responsive scroll-sm">

                        <table className="table bordered-table sm-table mb-0">

                            <thead>
                                <tr>
                                    <th>S.L</th>
                                    <th>Sender</th>
                                    <th>Receiver</th>
                                    <th>Company</th>
                                    <th>Message</th>
                                    <th>Date & Time</th>
                                    <th>Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {paginatedMeetings.length > 0 ? (
                                    paginatedMeetings.map((m, i) => {

                                        return (
                                            <tr key={m.id}>
                                                <td>{startIndex + i + 1}</td>

                                                <td>{m.sender?.fullName || "-"}</td>

                                                <td>{m.receiver?.fullName || "-"}</td>

                                                <td>
                                                    {m.sender?.Company?.name || m.receiver?.Company?.name || "-"}
                                                </td>

                                                <td>{truncateText(m.message)}</td>

                                                <td>{formatDateTime(m.meetingDateTime)}</td>

                                                <td>
                                                    <span
                                                        className={`px-12 py-4 ${getStatusClass(m.status)}`}
                                                        style={{
                                                            borderRadius: "999px",
                                                            fontSize: "10px",
                                                            display: "inline-block",
                                                            minWidth: "70px",
                                                            width: "80px",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        {m.status}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            {selectedLocation
                                                ? "No meetings for selected location"
                                                : "No meetings found"}
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>

                    </div>

                    {/* PAGINATION */}
                    <PaginationHelper
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                        totalItems={total}
                        pageSize={entries}
                    />

                </div>
            </div>
        </>
    );
};

export default MeetingLayer;